import React, { useState } from "react";
import { versionedUrl } from "../../lib/versioning";
import TermosModal from "./TermosModal";
import PoliticasModal from "./PoliticasModal";
import {
  FaInstagram,
  FaYoutube,
  FaTiktok,
} from "react-icons/fa";
import { AtendimentoContent } from "../AtendimentoModal/AtendimentoModal";

// const socialLinks = [
//   {
//     icon: (
//       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path fillRule="evenodd" clipRule="evenodd" d="M22 12.0614C22 17.083 18.344 21.2454 13.562 22V14.9701H15.893L16.336 12.0614H13.562V10.1739C13.562 9.37801 13.95 8.60227 15.192 8.60227H16.453V6.12718C16.453 6.12718 15.309 5.92997 14.215 5.92997C11.931 5.92997 10.437 7.32347 10.437 9.84485V12.0614H7.898V14.9701H10.437V22C5.657 21.2454 2 17.083 2 12.0614C2 6.50448 6.478 2 12 2C17.523 2 22 6.50448 22 12.0614Z" fill="white" />
//       </svg>
//     ),
//     href: "https://www.facebook.com/clarobrasil",
//     label: "Facebook"
//   },
//   {
//     icon: (
//       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M13.7124 10.6218L20.4133 3H18.8254L13.0071 9.61788L8.35992 3H3L10.0274 13.0074L3 21H4.58799L10.7324 14.0113L15.6401 21H21L13.7121 10.6218H13.7124ZM11.5375 13.0956L10.8255 12.0991L5.16017 4.16971H7.59922L12.1712 10.5689L12.8832 11.5655L18.8262 19.8835H16.3871L11.5375 13.096V13.0956Z" fill="white" />
//       </svg>
//     ),
//     href: "https://twitter.com/clarobrasil",
//     label: "Twitter"
//   },
//   { icon: <FaInstagram />, href: "https://www.instagram.com/clarobrasil", label: "Instagram" },
//   { icon: <FaYoutube />, href: "https://www.youtube.com/clarobrasil", label: "YouTube" },
//   {
//     icon: (
//       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path fillRule="evenodd" clipRule="evenodd" d="M20.888 2C21.502 2 22 2.498 22 3.112V20.888C22 21.502 21.502 22 20.888 22H3.112C2.498 22 2 21.502 2 20.888V3.112C2 2.498 2.498 2 3.112 2H20.888ZM8.279 9.775H5.544V18.64H8.279V9.775ZM15.357 9.495C14.278 9.447 13.262 10.004 12.723 10.94H12.669V9.774H10.089V18.539H12.855V14.149C12.855 13.007 13.073 11.872 14.518 11.872C15.8518 11.872 15.9544 13.0172 15.9623 14.0066L15.963 18.585H18.667V13.729C18.667 11.359 18.146 9.495 15.357 9.495ZM6.832 5.361C5.975 5.392 5.304 6.112 5.334 6.97C5.355 7.843 6.069 8.54 6.942 8.539V8.57C7.743 8.515 8.38 7.878 8.436 7.078C8.497 6.191 7.829 5.423 6.942 5.361C6.906 5.36 6.869 5.36 6.832 5.361Z" fill="white" />
//       </svg>
//     ),
//     href: "https://www.linkedin.com/company/claro-brasil",
//     label: "LinkedIn"
//   },
//   { icon: <FaTiktok />, href: "https://www.tiktok.com/@clarobrasil", label: "TikTok" },
// ];

const Footer = () => {
  const [isPoliticaModalOpen, setIsPoliticaModalOpen] = useState(false);
  const [politicaAceita, setPoliticaAceita] = useState(false);
  const [openModalRedirect, setOpenModalRedirect] = useState(false);

  return (
    <footer className="bg-claro-red w-full py-8 border-t border-white">
      <div className="container mx-auto px-4 lg:px-8 flex flex-col gap-8">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-8 w-full">

          {/* Right Content - Logo (Reordered for Mobile) */}
          <div className="flex-shrink-0 order-first lg:order-last">
            <img
              src={versionedUrl("/claro/images/logos/logo-claro-redonda.webp")}
              alt="Logo Claro"
              className="w-16 h-16 lg:w-20 lg:h-20 object-contain"
            />
          </div>

          {/* Left Content */}
          <div className="flex flex-col gap-6 w-full lg:w-auto">

            {/* Social Media Section */}
            {/* <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-6">
              <span className="text-white text-lg font-medium">Siga @clarobrasil</span>
              <div className="flex items-center gap-4">
                {socialLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white hover:opacity-80 transition-opacity text-xl"
                    aria-label={link.label}
                  >
                    {link.icon}
                  </a>
                ))}
              </div>
            </div> */}
          <div className="div1footer flex flex-col items-center lg:items-start gap-4 w-full">
            {/* Links and Accessibility with dot separators and underline */}
            <div className="w-full flex justify-center lg:justify-start">
              <div className="inline-flex flex-row flex-wrap justify-center items-center gap-0 lg:gap-6">


                <span className="inline-block border-b border-white/40 px-2">
                  <button
                    className="text-white hover:underline text-sm"
                    onClick={() => setIsPoliticaModalOpen(true)}
                  >
                    Aviso de Privacidade
                  </button>
                </span>

                <span aria-hidden="true" className="text-white opacity-90 px-2">·</span>

                <span className="inline-block border-b border-white/40 px-2">
                  <button
                    className="text-white hover:underline text-sm"
                    onClick={() => {
                      setOpenModalRedirect(true)
                    }}
                  >
                    Atendimento
                  </button>
                </span>
              </div>
            </div>

            <p className="text-white text-xs font-normal text-center lg:text-left w-full">
              ©{new Date().getFullYear()} Claro. Todos os direitos reservados - CNPJ: 40.432.544/0001-47 - Rua Henri Dunant, 780 - São Paulo - SP
            </p>
          </div>
        </div>

      </div>
      </div>

      <PoliticasModal
        isOpen={isPoliticaModalOpen}
        titulo="AVISO DE PRIVACIDADE DO CLARO ENERGIA"
        tipo="politicas"
        onClose={() => {
          setIsPoliticaModalOpen(false);
          const politicaStorage = localStorage.getItem("politica_aceita");
          const aceitos = politicaStorage === "TXT_POLITICAS_LIDO";
          setPoliticaAceita(aceitos);
        }}
      />      

      <AtendimentoContent isOpen={openModalRedirect} onClose={() => setOpenModalRedirect(false)}/>
      
    </footer>
  );
};

export default Footer;
